import api from './api';

export interface TestCaseDef {
  id: string;
  name: string;
  description?: string;
}

export interface TestRunResultItem {
  id: string;
  ok: boolean;
  log: string[];
  error?: string;
}

export interface TestRunSummary {
  runId: string;
  startedAt: string;
  endedAt?: string;
  results: TestRunResultItem[];
  errors: Array<{ id?: string; error: string }>;
}

export async function listCases(): Promise<TestCaseDef[]> {
  const { data } = await api.get('/testing/cases');
  return data?.data || [];
}

export async function runCases(cases?: string[]): Promise<TestRunSummary> {
  const { data } = await api.post('/testing/run', { cases });
  return data?.data;
}

export async function listRuns(): Promise<TestRunSummary[]> {
  const { data } = await api.get('/testing/runs');
  return data?.data || [];
}

export async function getRun(runId: string): Promise<TestRunSummary> {
  const { data } = await api.get(`/testing/runs/${runId}`);
  return data?.data;
}

export default { listCases, runCases, listRuns, getRun };


